import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const services = [
    {
      icon: 'ri-graduation-cap-fill',
      title: 'Admission universitaire',
      description: 'Sélection des établissements, constitution des dossiers et suivi complet de vos candidatures.'
    },
    {
      icon: 'ri-passport-fill',
      title: 'Visa et immigration',
      description: 'Montage complet du dossier, préparation administrative et coaching pour votre visa.'
    },
    {
      icon: 'ri-translate-2',
      title: 'Préparation linguistique',
      description: 'Cours adaptés pour DELF/DALF, TCF/TEF, TOEFL et IELTS selon vos objectifs.'
    },
    {
      icon: 'ri-compass-3-fill',
      title: 'Orientation pré-départ',
      description: 'Sessions complètes sur la vie étudiante, logement, budget et adaptation culturelle.'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Aide aux bourses et financement',
      description: 'Identification des opportunités et montage professionnel de vos candidatures.'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Accompagnement pendant les études',
      description: 'Assistance continue après installation, soutien académique et administratif.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section 
        className="relative bg-cover bg-center min-h-[600px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 61, 130, 0.85), rgba(0, 61, 130, 0.85)), url('https://public.readdy.ai/ai/img_res/d6f7c1be6fe9822a6f7e2250f99945e4.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              EduGlobe Campus – Votre avenir commence ici
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-8">
              Accompagnement professionnel pour vos études en France, au Canada et en Belgique.
            </p>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-calendar-check-fill mr-3 text-2xl"></i>
              Prenez rendez-vous dès aujourd'hui
            </button>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003D82] mb-4">Présentation</h2>
            <div className="w-24 h-1 bg-[#FF6B35] mx-auto mb-6"></div>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
              <strong>EduGlobe Campus</strong> est une agence spécialisée dans l'orientation, l'admission et l'accompagnement des étudiants souhaitant poursuivre leurs études à l'étranger. Nous offrons un suivi complet, professionnel et humain, de la sélection de l'université jusqu'à l'installation dans le pays d'accueil.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#003D82] mb-4">Nos services principaux</h2>
            <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="bg-white border-2 border-gray-100 rounded-xl p-8 hover:border-[#FF6B35] hover:shadow-xl transition-all cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B35]/10 rounded-full mb-6">
                  <i className={`${service.icon} text-3xl text-[#FF6B35]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#003D82] mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#003D82] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Prêt à concrétiser votre projet ?</h2>
          <p className="text-xl mb-8 text-white/90">
            Contactez-nous dès maintenant et commencez votre dossier sans délai.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact"
              className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-mail-send-fill mr-3 text-2xl"></i>
              Nous contacter
            </Link>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-[#003D82] px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
            >
              <i className="ri-customer-service-2-fill mr-3 text-2xl"></i>
              Parler à un conseiller
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
